class GalleryGrid {
	constructor() {
		this.$ = jQuery;
		this.listeners();
	}

	listeners() {
		var self = this;

		$(document).on("click", '[data-gallery-grid="true"]', function (e) {
			e.preventDefault();

			var data = {
				self: this,
				gallery_container: $(this).closest(".row"),
				images: $(this).closest(".gallery").data("images"),
				gallery_id: $(this).closest(".gallery").data("gallery-id"),
				images_per_row: $(this).closest(".gallery").data("images-per-row"),
				current_count: $(this).data("current-count"),
				action: "gallery_grid",
			};

			self.loadMore(data);
		});
	}

	loadMore(event) {
		const $self = $(event.self);
		const $gallery_container = $(event.gallery_container);

		let current_count = event.current_count;
		let images = event.images;
		let gallery_id = event.gallery_id;
		let images_per_row = event.images_per_row;
		let action = event.action;

		$self.css('pointer-events', 'none').css('opacity', '0.5');

		let postData = {
			action: action,
			nonce: ajax.nonce,
			data: JSON.stringify({
				current_count: current_count,
				images: images,
				gallery_id: gallery_id,
				images_per_row: images_per_row,
			}),
		};

		$gallery_container.LoadingOverlay('show', {
			imageClass: 'jquery-loading-overlay-icon',
			image: window.ajax.templateUrl + '/assets/svg/loading.svg',
			zIndex: 800,
			imageResizeFactor: 1,
			background: 'rgba(255, 255, 255, 0.09)'
		});

		$.ajax({
			url: ajax.url,
			method: "post",
			data: postData,
			dataType: "json",
			success: function (response) {
				$gallery_container.LoadingOverlay('hide');
				$self.fadeOut().parent().remove();

				if (response.html) {
					$.each(response.html, function (key, data) {
						$gallery_container.append(data);
						console.log(data);
						//$(data).hide().appendTo($gallery_container).fadeIn();
					});
				}
			}
		})
	}
}

export default GalleryGrid;
